import type { CameraTarget, MapCameraAdapter } from './types';

/**
 * Wrap a live map in the {@link MapCameraAdapter} seam (ADR-0017). `<MapCanvas>` builds one from
 * `useMap()`; a test injects a fake instead, which is what makes every later ticket's camera
 * behaviour — fly-to-result, cluster expansion, My location — assertable without Google Maps.
 */
export function createCameraAdapter(map: CameraTarget): MapCameraAdapter {
  return {
    centerAt: ({ lat, lon }, zoom) => {
      map.panTo({ lat, lng: lon });
      map.setZoom(zoom);
    },
    setZoom: (zoom) => map.setZoom(zoom),
  };
}
